import { Button, Empty, Skeleton, TablePaginationConfig, Tooltip } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { NotificationDetailsFilterFormValuesPaginated } from 'features/notification/components/type';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Notificationtype } from 'types/notification-type';
import { ReloadOutlined } from '@ant-design/icons';

dayjs.extend(utc);
type NotificationTableProps = {
    isUsersListLoading: boolean;
    typeReportList: Notificationtype[];
    itemsCount: number;
     refetch: any;
     tableParams: NotificationDetailsFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<NotificationDetailsFilterFormValuesPaginated>>;
};

export const NotificationsDetailTable = ({
    typeReportList,
    isUsersListLoading,
    itemsCount,
    tableParams,
    updateParams,
    refetch,

}: NotificationTableProps) => {
    const { t } = useTranslation();
    // const [showAddItemModal, setShowAddItemModal] = useState<boolean>(false);
    // const [notificationTypeEdit, setNotificationType] = useState(undefined)
    //  const [Data, setData] = useState<any>(/* Your initial data array */);
    // const { confirm } = Modal;
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<Notificationtype> | SorterResult<Notificationtype>[],
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };

    return (
        <StyledTableWrapper>

            <StyledTableHeader>
                <RecordCountBadge
                    text={t('vendingMachine.foundRecord')}
                    count={isUsersListLoading ? 0 : itemsCount || 0}
                />
                <Tooltip title="Refresh"> 
                    <Button
                        icon={<ReloadOutlined />}
                        loading={isUsersListLoading}
                        onClick={refetch}
                        className="refresh-btn"
                    >
                        Refresh
                    </Button>
                </Tooltip>


            </StyledTableHeader>
            <Table<Notificationtype>
                // loading={isUsersListLoading}
                // dataSource={typeReportList}
                className="cstltblwthldr"
                locale={{
                    emptyText: isUsersListLoading ? <Skeleton active={true} /> : <Empty />
                }}
                loading={isUsersListLoading && { indicator: <div><TableLoader /></div> }}
                dataSource={isUsersListLoading ? [] : typeReportList}
                rowKey='id'
                onChange={handleTableChange}
                pagination={{
                    current: tableParams.page,
                    defaultPageSize: tableParams.size,
                    total: itemsCount,
                }}
            >


                <Column<Notificationtype>
                    title={'Customer Name '}
                    dataIndex={'CustomerName'}
                />
                <Column<Notificationtype>
                    title={'Message '}
                    dataIndex={'Content'}
                    render={(value: string) => (
                        <div dangerouslySetInnerHTML={{ __html: value }} />
                    )}
                />
               <Column<Notificationtype>
    title="Send On"
    dataIndex="SendOn"
    render={(value: string) =>
        dayjs.utc(value).local().format("DD/MM/YYYY HH:mm")
    }
/>
                <Column<Notificationtype>
                    title={'Delivery Type '}
                    dataIndex={'DeliveryType'}
                />

                <Column<Notificationtype>
                    title={'Firebase Status '}
                    dataIndex={'status'}
                />
                <Column<Notificationtype>
                    title={'Error Description '}
                    dataIndex={'ErrorDescription'}
                />


            </Table>
        </StyledTableWrapper>
    );
};
